<mat-card>
  <img mat-card-image [src]="data.RESEARCH_IMG">
  <div>
    <img *ngIf="data.PROGRESS.done === data.PROGRESS.phase" src="../../../../assets/check_white_circle.png" width="30px"
      style="position: absolute; top: 15px; left: 15px; border-radius: 30px; box-shadow: 0px 0px 5px #7e7e7edb;">
    <img src="../../../../assets/share_white_circle.png" width="30px"
      style="position: absolute; top: 15px; right: 15px; cursor: pointer; border-radius: 30px; box-shadow: 0px 0px 5px #7e7e7edb;"
      (click)="share()">
  </div>

  <mat-card-content>
    <h4 class="text-center cut-text">{{ data.RESEARCH_NAME }}</h4>
  </mat-card-content>

  <mat-card-footer class="text-center" style="width: 80%; margin: 0 auto;">
    <!-- <p class="text-left text-primary" style="margin: 5px 0;">ประเภท {{ data.MEASURE_TYPE }}</p> -->
    <p class="my-3 text-center">{{ data.PROGRESS.phase }} WAVE | {{ data.PROGRESS.sum_measureOfResearch }} แบบทดสอบ</p>

    <button *ngIf="!data.PROGRESS.status_consent && !data.PROGRESS.status_sceen" class="btn rounded"
      style="background-color: #060E9F; color: #FFF; width: 100%; margin-bottom: -3px; margin-top: 0px; padding: 7px 0px 7px 0; font-size: small;"
      (click)="openConsent()">
      เข้าร่วมการวิจัย
      <img src="assets/edit-w.png" style="width: 17px; margin: 0px 7px 2px 10px;" alt="">
    </button>

    <button *ngIf="data.PROGRESS.status_consent && data.PROGRESS.done !== data.PROGRESS.sum_measureOfResearch" class="btn rounded"
      style="background-color: #32BEA6; color: #FFF; width: 100%; margin-bottom: -3px; margin-top: 0px; padding: 7px 0px 7px 0; font-size: small;"
      (click)="openDetail()">
      ทำงานวิจัยต่อ
      <img src="assets/pause-button.png" style="width: 18px; margin: 0px 7px 2px 10px;" alt="">
    </button>

    <p style="width: 100%;" class="">
      <ngb-progressbar [showValue]="true" type="success" [value]="progress"
        style="height: 1rem; font-size: 10px; margin-top: 20px;"></ngb-progressbar>
    </p>
    <p class="mt-3 text-center text-danger">แชร์ต่อได้รับ {{ data.COIN_SHARE }} coins<img src="assets/coin.png"
        style="width: 20px; margin-left: 5px;" alt=""></p>
  </mat-card-footer>
</mat-card>
